import * as React from "react";
import {
  Grid,
  Box,
  Stack,
  Typography,
  Button,
  Chip,
  alpha,
  IconButton,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AppNavbar from "../Components/AppNavbar";
import Search from "../Components/Search";
import ColorModeIconDropdown from "../theme/ColorModeIconDropdown";
import Copyright from "../Components/Copyright";
import { ApiManager } from "../Services/Networking";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Edit, Trash } from "lucide-react";
import Layout from "../Components/Layout";

export default function SoftwareAccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [groups, setGroups] = useState(location.state?.updatedList || []);
  const [loading, setLoading] = useState(!location.state?.updatedList);

  useEffect(() => {
    if (!location.state?.updatedList) fetchData();
  }, [location.state?.updatedList]);

  const fetchData = async () => {
    setLoading(true);
    const res = await ApiManager.getEmployeeSoftwareAccess();
    const access = await ApiManager.getSoftwareAccess();
    if (res.status === "success" && access.status === "success") {
      debugger;
      const grouped = res.data.reduce((acc, curr) => {
        const existing = acc.find((item) => item.id === curr.id);
        const empData = curr.emp_id
          ? { id: curr.emp_id, name: curr.emp_name }
          : null;

        if (existing) {
          if (empData && !existing.employees.find((e) => e.id === empData.id)) {
            existing.employees.push(empData);
          }
        } else {
          acc.push({ ...curr, employees: empData ? [empData] : [] });
        }
        return acc;
      }, []);
      setGroups(
        grouped.map((x) => {
          const sa = access.data.find((y) => y.id == x.sa_id);
          return { ...x, ...sa };
        }),
      );
    }
    setLoading(false);
  };

  const deleteGroup = async (id) => {
    if (window.confirm("Are you sure?")) {
      setLoading(true);
      const res = await ApiManager.deleteSoftwareAccess(id);
      if (res.status === "success")
        setGroups((prev) => prev.filter((g) => g.id !== id));
      setLoading(false);
    }
  };

  const columns = [
    { field: "software_access_name", headerName: "Group Name", flex: 1 },
    {
      field: "software",
      headerName: "Access Rights",
      flex: 1.5,
      renderCell: (params) => {
        const rights = [];
        if (params.row.ats_employee) rights.push("ATS Emp");
        if (params.row.ats_web_admin) rights.push("ATS Admin");
        if (params.row.ats_web_hr) rights.push("ATS HR");
        if (params.row.hrm_admin) rights.push("HRM Admin");
        return (
          <Stack
            direction="row"
            alignItems="center"
            height="100%"
            spacing={0.5}
            sx={{ py: 1 }}
          >
            {rights.map((r) => (
              <Chip key={r} label={r} />
            ))}
          </Stack>
        );
      },
    },
    {
      field: "employees",
      headerName: "Employees",
      flex: 2,
      renderCell: (params) => (
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          height="100%"
          flexWrap="wrap"
          sx={{ py: 1 }}
        >
          {params.value?.length > 0 ? (
            params.value.map((emp) => (
              <Tooltip key={emp.id} title={emp.name} arrow>
                <Chip label={emp.id} variant="outlined" color="primary" />
              </Tooltip>
            ))
          ) : (
            <Typography variant="caption" color="text.secondary">
              None
            </Typography>
          )}
        </Stack>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      renderCell: (params) => (
        <Stack direction="row" spacing={1} alignItems="center" height="100%">
          <IconButton
            onClick={() =>
              navigate("/software-access/form", {
                state: { group: params.row, fullList: groups },
              })
            }
          >
            <Edit size={18} />
          </IconButton>
          <IconButton onClick={() => deleteGroup(params.row.id)}>
            <Trash size={18} />
          </IconButton>
        </Stack>
      ),
    },
  ];

  const filteredRows = groups.filter((row) =>
    row.software_access_name.toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <Layout name="SOFTWARE ACCESS">
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12 }}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Search
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <span style={{ flex: 1 }}></span>
            <Button
              variant="contained"
              onClick={() =>
                navigate("/software-access/form", {
                  state: { group: null, fullList: groups },
                })
              }
            >
              Create New
            </Button>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12 }} style={{ minHeight: "580px" }}>
          <Box sx={{ height: 600 }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              rowHeight={70}
              loading={loading}
              getRowId={(row) => row.emp_id}
              disableRowSelectionOnClick
            />
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}
